var _excluded = ["invert", "size"];

var _templateObject;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import { colorWhite } from "@nib-components/theme";
import { sizePropType } from "../../utils";
export var StyledPath = styled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", "; /* colorBrandBase */\n"])), function (props) {
  return props.invert ? colorWhite : props.fill;
}); // small === min-height from brand guidelines

var sizes = {
  small: {
    width: "115.87px",
    height: "32px"
  },
  header: {
    width: "144.84px",
    height: "40px"
  },
  medium: {
    width: "173.81px",
    height: "48px"
  },
  large: {
    width: "231.74px",
    height: "64px"
  }
};

var RealLogo = function RealLogo(props) {
  var invert = props.invert,
      _props$size = props.size,
      size = _props$size === void 0 ? "small" : _props$size,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 48",
    width: sizes[size].width,
    height: sizes[size].height,
    "aria-label": "Real Insurance",
    role: "img"
  }, otherProps), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M95.028 8.12h6.874v3.797h.081c1.043-2.748 3.458-4.205 6.497-4.205a7.516 7.516 0 0 1 1.668.166v6.45a9.898 9.898 0 0 0-2.707-.417c-3.504 0-5.332 2.415-5.332 5.122v10.705h-7.081V8.121ZM118.28 20.66c.126 2.958 1.831 4.917 4.83 4.917 1.711 0 3.376-.794 4.041-2.377h6.623c-1.291 5-5.916 7.169-10.746 7.169-7.04 0-11.829-4.246-11.829-11.494 0-6.625 5.288-11.373 11.663-11.373 7.747 0 11.622 5.84 11.289 13.164l-15.871-.006Zm8.787-3.957c-.123-2.418-1.831-4.415-4.205-4.415-2.5 0-4.167 1.79-4.582 4.415h8.787ZM136.937 14.784c.125-2.83 1.46-4.672 3.375-5.787 1.916-1.116 4.412-1.501 6.871-1.501 5.113 0 10.077 1.127 10.077 7.247V24.2c0 1.83 0 3.83.832 5.548h-7.119a8.593 8.593 0 0 1-.417-2.044c-1.831 1.915-4.538 2.666-7.122 2.666-4.123 0-7.373-2.082-7.373-6.538 0-7.04 7.665-6.5 12.579-7.5 1.209-.247 1.878-.665 1.878-1.996 0-1.627-1.96-2.249-3.417-2.249-1.959 0-3.212.876-3.542 2.704l-6.622-.006ZM146.1 25.99c3.375 0 4.5-1.916 4.333-6.372-1.001.625-2.835.75-4.38 1.168-1.583.374-2.92 1.04-2.92 2.748 0 1.708 1.384 2.456 2.967 2.456ZM160.802 0h7.081v29.738h-7.081V0ZM95.016 37.908h.876v9.196h-.876v-9.196ZM98.056 37.908h.978l5.373 7.777v-7.777h.876v9.196h-.978l-5.359-7.78h-.023v7.78h-.876l.009-9.196ZM107.803 44.076c-.038 1.895 1.326 2.473 2.999 2.473.967 0 2.435-.529 2.435-1.866 0-1.045-1.042-1.46-1.892-1.662l-2.044-.502c-1.083-.271-2.073-.785-2.073-2.216 0-.9.584-2.587 3.165-2.587 1.816 0 3.411.978 3.402 2.858h-.876c-.053-1.404-1.212-2.114-2.511-2.114-1.197 0-2.304.465-2.304 1.831 0 .876.642 1.224 1.387 1.405l2.242.552c1.3.347 2.383.914 2.383 2.42 0 .631-.257 2.628-3.504 2.628-2.175 0-3.773-.978-3.67-3.212l.861-.008ZM115.67 37.908h.876V43.6c0 2.137 1.004 2.949 2.692 2.949 1.688 0 2.716-.812 2.704-2.95v-5.69h.876V43.8c0 1.892-1.019 3.504-3.58 3.504s-3.568-1.612-3.568-3.504v-5.893ZM124.848 37.908h4.21c1.522 0 2.795.736 2.795 2.395 0 1.168-.605 2.111-1.787 2.336v.026c1.197.152 1.544.979 1.609 2.074.038.63.038 1.892.423 2.356h-.966c-.217-.362-.217-1.045-.243-1.428-.079-1.29-.181-2.718-1.842-2.654h-3.323V47.1h-.876v-9.193Zm.876 4.38h3.27c1.072 0 1.986-.668 1.986-1.79 0-1.12-.672-1.827-1.986-1.827h-3.27v3.617ZM136.893 37.908h.978l3.621 9.196h-.94l-1.122-2.859h-4.199l-1.106 2.859h-.941l3.709-9.196Zm-1.39 5.601h3.618l-1.778-4.713-1.84 4.713ZM142.818 37.908h.978l5.355 7.777h.027v-7.777h.876v9.196h-.97l-5.358-7.78h-.024v7.78h-.876l-.008-9.196ZM158.875 40.688a2.79 2.79 0 0 0-2.821-2.228c-2.432 0-3.463 2.044-3.463 4.045 0 2 1.031 4.044 3.463 4.044 1.7 0 2.78-1.314 2.95-2.95h.876c-.246 2.255-1.677 3.697-3.826 3.697-2.882.01-4.342-2.277-4.342-4.791 0-2.515 1.443-4.79 4.339-4.79 1.752 0 3.467 1.043 3.694 2.973h-.87ZM161.477 37.908h6.345v.748h-5.472v3.323h5.131v.748h-5.131v3.63h5.548v.747h-6.424l.003-9.196Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M20.309 21.433c4.506 1.86 4.558 4.316.117 5.464-4.442 1.147-11.765.566-16.27-1.291-4.506-1.857-4.556-4.313-.112-5.458 4.445-1.144 11.762-.569 16.265 1.285ZM67.182 44.56 51.764 48l-35.69-16.352 17.88-2.395L67.183 44.56Z",
    fill: "#D3BE96"
  }), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M51.682.95H66.63v8.245h.184C69.074 3.212 74.33.044 80.944.044a16.393 16.393 0 0 1 3.624.362v14.043a21.561 21.561 0 0 0-5.887-.909c-7.61 0-11.595 5.257-11.595 11.146v23.282H51.682V.95Z",
    fill: "#912680"
  }), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M173.116 34.798a2.286 2.286 0 0 1 1.247 1.253 2.382 2.382 0 0 1-.496 2.599 2.34 2.34 0 0 1-.751.496 2.48 2.48 0 0 1-1.86 0 2.273 2.273 0 0 1-.747-.496 2.386 2.386 0 0 1 0-3.35c.213-.214.467-.385.747-.502a2.48 2.48 0 0 1 1.86 0Zm-1.725.319c-.237.1-.451.246-.631.429-.179.184-.32.4-.415.64a2.183 2.183 0 0 0 0 1.582 1.934 1.934 0 0 0 1.069 1.075c.245.1.509.15.774.146a1.957 1.957 0 0 0 1.836-1.227 2.133 2.133 0 0 0 0-1.582 1.936 1.936 0 0 0-1.048-1.07 1.957 1.957 0 0 0-.788-.157 1.99 1.99 0 0 0-.797.164Zm-.062 3.212v-2.704h1.049c.242-.02.484.048.68.193a.72.72 0 0 1 .21.56.78.78 0 0 1-.055.31.617.617 0 0 1-.149.225.732.732 0 0 1-.219.146 1.174 1.174 0 0 1-.266.078l.812 1.21h-.394l-.765-1.21h-.564v1.21l-.339-.018Zm1.084-1.504a.875.875 0 0 0 .262-.053.406.406 0 0 0 .184-.143.447.447 0 0 0 .07-.268.424.424 0 0 0-.055-.234.365.365 0 0 0-.146-.143.566.566 0 0 0-.204-.073 1.59 1.59 0 0 0-.243-.017h-.613v.943h.444c.102.008.201.005.301-.003v-.009Z",
    fill: "#000"
  }));
};

RealLogo.displayName = "RealLogo";
RealLogo.defaultProps = {
  invert: false,
  size: "small"
};
export default RealLogo;